import React, { useState } from "react";
import { Providers } from "@microsoft/mgt-element";
import { FaMicrosoft } from "react-icons/fa";

function MicrosoftSignInButton({
  label = "Se connecter avec Microsoft",
  compact = false,
}) {
  const [isSigningIn, setIsSigningIn] = useState(false);

  const handleSignIn = async () => {
    if (!Providers.globalProvider || isSigningIn) return;

    try {
      setIsSigningIn(true);
      await Providers.globalProvider.login();
    } catch (error) {
      console.error("Erreur de connexion Microsoft :", error);
    } finally {
      setIsSigningIn(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleSignIn}
      disabled={isSigningIn}
      className={`inline-flex items-center gap-2.5 rounded-md bg-[#0f6cbd] text-sm font-semibold text-white shadow-sm transition-colors hover:bg-[#115ea3] disabled:cursor-wait disabled:opacity-70 ${
        compact ? "h-10 px-4" : "h-11 px-5"
      }`}
    >
      <FaMicrosoft className="h-4 w-4" aria-hidden="true" />
      {isSigningIn ? "Connexion en cours…" : label}
    </button>
  );
}

export default MicrosoftSignInButton;
